var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoutBtn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.85,
    height: 26,
    viewBox: "0 0 31.85 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n            .cls-1{fill:#fff}\r\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "arrow_2_",
    "data-name": "arrow (2)",
    transform: "translate(0 -41.115)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_88",
    "data-name": "Group 88",
    transform: "translate(0 41.115)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_131",
    d: "M13 65.165a.529.529 0 0 1-.041-.275c.014-.074-.034-.135-.142-.183s-.163-.085-.163-.111-.078-.047-.234-.061l-.234-.02H5.85a3.128 3.128 0 0 1-2.3-.955 3.129 3.129 0 0 1-.955-2.3v-14.3a3.129 3.129 0 0 1 .955-2.3 3.13 3.13 0 0 1 2.3-.955h6.5a.614.614 0 0 0 .416-.132.675.675 0 0 0 .2-.4 3.418 3.418 0 0 0 .061-.477 5.054 5.054 0 0 0-.01-.538q-.02-.325-.02-.406a.659.659 0 0 0-.65-.65H5.85a5.635 5.635 0 0 0-4.134 1.716A5.635 5.635 0 0 0 0 46.965v14.3A5.634 5.634 0 0 0 1.716 65.4a5.633 5.633 0 0 0 4.134 1.715h6.5a.616.616 0 0 0 .416-.132.675.675 0 0 0 .2-.4 3.425 3.425 0 0 0 .061-.477 5.049 5.049 0 0 0-.01-.538Q13 65.246 13 65.165z",
    className: "cls-1",
    "data-name": "Path 131",
    transform: "translate(0 -41.115)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_132",
    d: "M133.3 61.682l-11.05-11.05a1.3 1.3 0 0 0-2.214.914V57.4h-9.1a1.318 1.318 0 0 0-1.3 1.3v7.8a1.318 1.318 0 0 0 1.3 1.3h9.1v5.85a1.293 1.293 0 0 0 2.214.914l11.05-11.05a1.276 1.276 0 0 0 0-1.829z",
    className: "cls-1",
    "data-name": "Path 132",
    transform: "translate(-101.833 -49.596)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutBtn);
export default __webpack_public_path__ + "static/media/logout-btn.2617d4a395c932074ea36435f22d9151.svg";
export { ForwardRef as ReactComponent };